import { Money } from "@upserve/financials";
import { contains, equals } from "ramda";
import React from "react";
import styled from "styled-components";

import Modal from "components/modal";

import {
  DigitalGiftCardDeliveryMethod,
  type DigitalGiftCardOrderApiResponse,
} from "types/digital_gift_cards";

const success = require("images/icons/success-check.svg");

const StyledConfirmationModal = styled.div`
  padding: 60px 30px 60px 30px;
  overflow-y: auto;

  font-size: 24px;

  text-align: center;

  @media (max-width: 1024px) {
    width: 80%;
  }
`;

const StyledConfirmationHeader = styled.h1`
  font-family: "Graphik", sans-serif;
  font-weight: bold;
  font-size: 1.75rem; // ~24px based on 14px root font-size; decrease to 1.5rem for 16px root
  color: #212322;
`;

const StyledConfirmationContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;

  font-size: 1rem; // 14px based on 14px root font-size; decrease to .875rem for 16px root
  line-height: 1.5rem; // ~22.5px based on 14px root font-size; decrease to 1.33rem for 16px root
`;

const StyledBoldContent = styled.span`
  font-weight: 600;
`;

type ConfirmationModalProps = {
  orderResponse: DigitalGiftCardOrderApiResponse;
  ccLastFour: string;
  closeModalClick: () => void;
};

export default function ConfirmationModal({
  orderResponse,
  ccLastFour,
  closeModalClick,
}: ConfirmationModalProps) {
  const { digitalGiftCards, consumerEmail } = orderResponse;
  const { deliveryMethod, recipient, recipientEmail, recipientPhone, amount } =
    digitalGiftCards[0];

  const formattedPhone: string = recipientPhone
    ? recipientPhone.replace(/(\d{3})(\d{3})(\d{4})/, "($1) $2-$3")
    : "";

  const recipientInfo = contains(deliveryMethod, [
    DigitalGiftCardDeliveryMethod.EMAIL_RECEIPT,
    DigitalGiftCardDeliveryMethod.TEXT_RECEIPT,
  ]) && (
    <>
      <br />
      Sent to:
      <br />
      <StyledBoldContent>{recipient}</StyledBoldContent> at{" "}
      <StyledBoldContent>
        {equals(DigitalGiftCardDeliveryMethod.TEXT_RECEIPT, deliveryMethod)
          ? formattedPhone
          : recipientEmail}
      </StyledBoldContent>
    </>
  );
  return (
    <Modal onClose={closeModalClick} className="">
      <StyledConfirmationModal>
        <img
          alt="success"
          src={success}
          style={{ width: "65px", height: "65px" }}
        />
        <StyledConfirmationHeader>Thank you!</StyledConfirmationHeader>
        <StyledConfirmationContent>
          <div>
            Your card is on the way.
            <br />
            Gift Card Amount:{" "}
            <StyledBoldContent>{Money(amount).format()}</StyledBoldContent>
            {recipientInfo}
            <br />
            Paid with card # ....{ccLastFour}
          </div>
          <div>
            We'll send an email receipt to:
            <br />
            {consumerEmail}
          </div>
        </StyledConfirmationContent>
      </StyledConfirmationModal>
    </Modal>
  );
}
